import React, { ElementRef, PropsWithChildren, forwardRef } from 'react';
import { COLORS, Gradient } from '../../config/designSystem/Colors';
import { Caption2Bold } from '../../config/designSystem/typography';
import { GradientView } from './GradientView';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity } from 'react-native';

export interface GradientButtonProps extends PropsWithChildren {
    gradient: Gradient;
    onPress: () => void;
    label: string;
}



export const GradientButton = forwardRef<ElementRef<typeof TouchableOpacity>, GradientButtonProps>(({gradient, label, onPress}, ref ) => {

  return (
    <TouchableOpacity onPress={onPress} style={{width: '100%'}} ref={ref}>
      <GradientView gradient={gradient} style={{
        borderRadius: SPACING['sp-24'],
        paddingVertical: SPACING['sp-12'],
        paddingHorizontal: SPACING['sp-24'],
        alignItems: 'center'

      }}>
        <Caption2Bold color={COLORS.content['inverse-primary']}>{label}</Caption2Bold>
      </GradientView>

    </TouchableOpacity>
  );
});


